export default {"src":"/_next/static/media/card_check-hover.1965915f.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};